import { TaskMetadataReason } from "__graphql__/types";

export const STOCK_CHECK_METADATA_REASONS = [
  TaskMetadataReason.dropping,
  TaskMetadataReason.expensive,
  TaskMetadataReason.extra,
  TaskMetadataReason.low_stock,
  TaskMetadataReason.missing,
  TaskMetadataReason.tobacco,
  TaskMetadataReason.bbd_missing,
];
